import React from 'react'



export const FORMS = {
  newsletter: 'NEWSLETTER'
}

// Header Menu Title Link
export const HEADER_MENU_TITLE_LINK = {
  services: {
    integration: 'Integration',
    design: 'Design',
    consultation: 'Consultation',
    trainingMaintenance: 'Training & Maintenance',
    avEngineering: 'AV Engineering',
    avProgramming: 'AV IT Programming',
    procurement: 'Procurement',
    remoteManagement: 'System Remote Management Services'
  },

  solutions: {
    audioVisual: 'Audio Visual Integration',
    videoSignage: 'Video & Signage',
    unifiedCommunication: 'Unified Communication',
    controlSystem: 'Control & Command System',
    publicAddress: 'Public Address System',
    theatricalLighting: 'Theatrical Lighting System',
    securitySurveillance: 'Security Surveillance System',
    hearingLoop: 'Hearing Loop System'
  },

  company: {
    certifications: 'Certifications & Licenses',
    caseStudy: 'Case Study',
    aboutUs: 'About Us',
    newsletter: 'Newsletter',
    quote: 'Get A Quote',

  }
}

export const ICONS = {
  usa: <svg viewBox="0 0 800.685 800.685" style={{ enableBackground: 'new 0 0 800.685 800.685' }} >
    <path d="M800.196,248.076c-0.079-0.108-0.205-0.206-0.318-0.311c-6.391-6.022-50.159-2.275-50.159-2.275s-0.271,0.932-0.969,2.275
   c-1.485,2.859-4.936,7.608-11.979,9.373c-10.354,2.586-157.908,5.172-161.791-5.181c-0.653-1.75-1.818-3.104-3.258-4.192
   c-7.063-5.335-21.334-3.572-21.334-3.572s-1.106,1.468-2.892,3.572c-4.027,4.749-11.538,12.752-17.817,14.545
   c-7.013,2.005-8.585-6.84-7.745-14.545c0.245-2.247,0.688-4.405,1.271-6.16c1.812-5.438-15.428-24.205-29.918-33.632
   c-6.192-4.025-11.893-6.361-15.382-5.198c-11.647,3.883-72.487-19.414-72.487-19.414H193.214H28.763c0,0-0.792,8.261-2.147,15.461
   c-0.127,0.667-0.257,1.32-0.393,1.963c-0.638,3.021-1.376,5.687-2.207,7.188c-0.54,0.981-1.117,1.474-1.722,1.27
   c-0.556-0.184-1.367-0.653-2.327-1.27c-5.751-3.691-17.458-13.335-19.68-7.79c-0.709,1.771-0.035,4.533,1.279,7.79
   c3.495,8.65,11.664,20.935,11.664,28.452c0,1.654,0,5.685,0,11.34c0,6.453,0,15.019,0,24.615c0,12.354,0,26.394,0,39.79
   c0,8.698,0,17.113,0,24.615c0,13.418,0,23.909,0,27.781c0,5.052,3.265,8.64,7.358,12.009c7.435,6.127,17.61,11.546,15.939,23.768
   c-0.039,0.284-0.045,0.564-0.069,0.847c-1.217,14.422,16.472,29.532,28.742,39.79c3.649,3.051,6.822,5.676,8.865,7.719
   c3.774,3.775,9.119,10.467,14.632,16.895c7.727,9.014,15.784,17.514,20.315,16.762c7.766-1.295,22.005-6.475,31.065,3.883
   c7.56,8.643,42.152,17.273,59.413,19.146h9.94c9.832-1.316,35.456-4.867,50.457,0c5.52,1.793,9.604,4.719,10.919,9.326
   c1.528,5.346,4.308,10.566,7.449,15.289c7.509,11.279,17.142,19.658,17.142,19.658s6.475-10.354,10.356-18.121
   c0.297-0.596,0.687-1.104,1.138-1.537c2.18-2.104,6.041-2.312,10.43,0c6.632,3.496,14.46,12.76,19.498,30.016
   c1.013,3.477,2.396,6.723,4.025,9.773c5.7,10.674,14.598,18.828,22.798,24.613c10.465,7.383,19.773,10.912,19.773,10.912
   s0-4.547,0.083-10.912c0.093-7.191,0.291-16.697,0.714-24.613c0.139-2.613,0.302-5.062,0.495-7.188
   c1.294-14.234,44.009-27.182,51.773-28.479c7.768-1.293,59.541,22.008,59.541,14.244c0-6.521,8.226-12.139,17.755-18.367
   c1.82-1.189,3.681-2.396,5.547-3.641c4.116-2.748,9.204-0.309,14.114,3.641c8.995,7.219,17.404,19.5,18.24,14.484
   c1.293-7.771,25.89-3.883,28.476,5.174c1.524,5.344,3.497,12.938,4.599,20.131c0.767,4.998,1.108,9.811,0.583,13.525
   c-0.363,2.545,1.315,6.627,4.007,11.086c6.887,11.42,20.383,25.355,23.176,22.562c1.706-1.703,3.664-11.434,4.442-22.562
   c0.583-8.346,0.49-17.475-0.86-24.611c-0.944-4.975-2.496-8.982-4.878-11.068c-4.604-4.029-8.18-15.992-9.829-28.721
   c-1.108-8.602-1.342-17.529-0.407-24.619c0.791-6.014,2.42-10.693,5.061-12.674c4.068-3.051,18.512-14.281,33.693-27.113
   c9.606-8.121,19.513-16.881,27.268-24.613c11.199-11.164,17.926-20.192,12.814-22.051c-8.366-3.045-9.562-8.799-8.615-17.739
   c0.664-6.264,2.371-14.078,3.436-23.677c0.039-0.334,0.086-0.623,0.129-0.938c2.915-21.554,18.086,4.392,24.474-24.954
   c1.341-6.175,4.817-11,9.393-14.836c17.461-14.656,51.124-14.71,44.966-18.813c-1.896-1.271-3.253-3.322-4.066-5.802
   c-2.514-7.642,0.136-19.402,7.949-25.264c4.006-3.001,12.067-8.515,20.148-14.526C790.469,262.837,803.375,252.046,800.196,248.076
   z"/>
  </svg>,

  project: <svg viewBox="0 0 496 496"><path d="m80 192c26.472656 0 48-21.527344 48-48s-21.527344-48-48-48c-4.425781 0-8 3.574219-8 8v32h-32c-4.425781 0-8 3.574219-8 8 0 26.472656 21.527344 48 48 48zm0-40c4.425781 0 8-3.574219 8-8v-30.984375c13.792969 3.550781 24 16.105469 24 30.984375 0 17.648438-14.351562 32-32 32-14.878906 0-27.433594-10.207031-30.984375-24zm0 0" /><path d="m160 104h128v16h-128zm0 0" /><path d="m160 136h128v16h-128zm0 0" /><path d="m160 168h128v16h-128zm0 0" /><path d="m160 224h-120c-4.425781 0-8 3.574219-8 8v48c0 4.425781 3.574219 8 8 8h120c4.425781 0 8-3.574219 8-8v-48c0-4.425781-3.574219-8-8-8zm-8 48h-104v-32h104zm0 0" /><path d="m160 304h-120c-4.425781 0-8 3.574219-8 8v144c0 4.425781 3.574219 8 8 8h120c4.425781 0 8-3.574219 8-8v-144c0-4.425781-3.574219-8-8-8zm-8 16v96h-104v-96zm-104 128v-16h104v16zm0 0" /><path d="m200 320h56v-16h-64c-4.425781 0-8 3.574219-8 8v144c0 4.425781 3.574219 8 8 8h64v-16h-56v-16h56v-16h-56zm0 0" /><path d="m400 250.414062v-242.414062c0-4.425781-3.574219-8-8-8h-320c-4.425781 0-8 3.574219-8 8v24h-24c-4.425781 0-8 3.574219-8 8v24h-24c-4.425781 0-8 3.574219-8 8v416c0 4.425781 3.574219 8 8 8h320c4.425781 0 8-3.574219 8-8v-7c12.535156 4.449219 25.960938 7 40 7 66.167969 0 120-53.832031 120-120 0-57.953125-41.289062-106.433594-96-117.585938zm-320-234.414062h304v232.40625c-2.65625-.175781-5.296875-.40625-8-.40625s-5.34375.230469-8 .40625v-208.40625c0-4.425781-3.574219-8-8-8h-280zm-32 32h304v202.414062c-5.496094 1.121094-10.800781 2.738282-16 4.585938v-183c0-4.425781-3.574219-8-8-8h-280zm272 432h-304v-400h304v181.945312c-38.015625 20.152344-64 60.101563-64 106.054688s25.984375 85.894531 64 106.054688zm56-8c-57.34375 0-104-46.65625-104-104s46.65625-104 104-104 104 46.65625 104 104-46.65625 104-104 104zm0 0" /><path d="m376 280c-48.519531 0-88 39.480469-88 88h16c0-39.703125 32.296875-72 72-72s72 32.296875 72 72h16c0-48.519531-39.480469-88-88-88zm0 0" /><path d="m368 372.6875-45.65625 45.65625 11.3125 11.3125 48-48c1.503906-1.496094 2.34375-3.527344 2.34375-5.65625v-48h-16zm0 0" /><path d="m200 224h88v16h-88zm0 0" /><path d="m200 256h88v16h-88zm0 0" /></svg>,

  calender: <svg
    viewBox="0 0 512 512" style={{ enableBackground: 'new 0 0 512 512' }}>
    <path d="M452,40h-24V0h-40v40H124V0H84v40H60C26.916,40,0,66.916,0,100v352c0,33.084,26.916,60,60,60h392
			c33.084,0,60-26.916,60-60V100C512,66.916,485.084,40,452,40z M472,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V188
			h432V452z M472,148H40v-48c0-11.028,8.972-20,20-20h24v40h40V80h264v40h40V80h24c11.028,0,20,8.972,20,20V148z"/>
    <rect x="76" y="230" width="40" height="40" />
    <rect x="156" y="230" width="40" height="40" />
    <rect x="236" y="230" width="40" height="40" />
    <rect x="316" y="230" width="40" height="40" />
    <rect x="396" y="230" width="40" height="40" />
    <rect x="76" y="310" width="40" height="40" />
    <rect x="156" y="310" width="40" height="40" />
    <rect x="236" y="310" width="40" height="40" />
    <rect x="316" y="310" width="40" height="40" />
    <rect x="76" y="390" width="40" height="40" />
    <rect x="156" y="390" width="40" height="40" />
    <rect x="236" y="390" width="40" height="40" />
    <rect x="316" y="390" width="40" height="40" />
    <rect x="396" y="310" width="40" height="40" />
  </svg>
}